//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { marked } from 'marked'

export default {
  data() {
    return {
      promotion: null,
      opt_in_status: {
        'NotAllowed': 0,
        'Allowed': 1,
        'OptedIn': 2
      },
      promotion_types: {
        'Regular': 1,
        'Tournament': 2,
        'Events': 3,
        'Club': 4,
        'Deposit': 5
      }
    }
  },
  mounted(){},
  computed: {
    isOptedIn() {
      return (_.get(this.promotion, 'opt_in_button') === this.opt_in_status.OptedIn)
    },
    isClubPromotion(){
      return (_.get(this.promotion, 'promotion_type') === this.promotion_types.Club)
    },
    isEventPromotion(){
      return (_.get(this.promotion, 'promotion_type') === this.promotion_types.Events)
    }
  },
  methods: {
    beforeOpen (data) {
      this.promotion = _.get(data, 'params.promotion')
      this.closedCb = _.get(data, 'params.closedCb')
      // this.error = ""
      window.dispatchEvent(new Event('resize'));
    },
    close() {
      this.$modal.hide('modal-promotion')
    },
    closed() {
      this.closedCb()
    },
    renderMd(string) {
      try {
        return marked.parse(string)
      } catch (e) {
        return e.message
      }
    },
    buttonClass() {
      if (!this.isOptedIn) {
        if (this.isClubPromotion || this.isEventPromotion) {
          return 'bg-primary-500 hover:bg-primary-600'
        }
        return 'bg-gray-500 hover:bg-gray-600'
      }

      return 'bg-primary-500 hover:bg-primary-600'
    },
    buttonText() {
      if (this.isOptedIn) {
        if (this.isClubPromotion) {
          //SPF-1629 - Change popup button for club bet promotion
          return 'IR AL CLUB BET777'
        } else if (this.isEventPromotion) {
          return  'IR AL EVENTOS'
        }
        return 'Opted in'
      }

      return 'Opt in'
    },
    showOptin() {
      // return _.includes([0, 1, 2], _.get(this.promotion, 'opt_in_button'))
      return _.includes([1, 2], _.get(this.promotion, 'opt_in_button'))
    },

    async goTo(url, query = null) {
      let route = _.startsWith(url, 'http') ? url : this.localePath(url);
      if(route) {
        await this.$router.push({ path: route, query: query})
      }
    },

    async optInButtonAction() {
      if (this.isOptedIn) {
        if (this.isClubPromotion) {
          this.close()
          await this.goTo('/club-promociones')
        } else if (this.isEventPromotion) {
          this.close()
          if (!_.get(this.$store.state, 'auth.user.id')) { // not logged
            this.$modal.show('modal-login')
            return
          }
          await this.goTo('/promotion-events', {promotionId: this.promotion.id})
        }
      } else {
        return await this.optIn();
      }
    },
    async optIn() {
      try {
        let response = await this.$new_cms().get('api/sport/promotion/optin/'+ this.promotion.id)
        this.close()
        if (_.get(response, 'data.result')) {
          if (this.isEventPromotion && !_.get(response, 'data.error')) {
            this.$modal.show('modal-redirect', {
              title: this.$t('You can now make your prediction!'),
              content: this.$t('You have successfully applied to participate!'),
              button_text: this.$t('GO TO THE POOL'),
              path: '/promotion-events/',
              query: { promotionId: this.promotion.id }
            })
          } else {
            if(_.get(response, 'data.popup')) {
              this.$modal.show('modal-generic', {
                title: _.get(response, 'data.popup.title'),
                content: _.get(response, 'data.popup.msg')
              })
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
